import { Button, IconButton, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { MultiPictureUploadSubtypeDataModel, MultiPictureUploadSubtypeResponse } from "../../../../../../types/actionModule/subtypes/multiPictureUploadModels";
import { Download } from "@mui/icons-material";
import { Link } from "react-router-dom";

interface Props {
    subtype: MultiPictureUploadSubtypeResponse;
    subtypeData: MultiPictureUploadSubtypeDataModel;
}

export default function MultiPictureUploadSubtypeSummary(props: Props) {
    const { t } = useTranslation();

    return <Stack direction="row" alignItems="center">
        <Typography>
            {t("incentivationPage.pictureUpload.numberUploadedImages", { count: props.subtypeData.images.length })}
        </Typography>

        {
            props.subtypeData.bundleDownloadUrl &&
            <Link to={props.subtypeData.bundleDownloadUrl} target="_blank">
                <IconButton>
                    <Download />
                </IconButton>
            </Link>
        }
    </Stack>
}
